import React, { Component } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import ButtonContent from '../ButtonContent';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  dialogPaper: {
    minHeight: '80vh',
    maxHeight: '80vh',
  }
});

const MuiDialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <DialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
});


class ImageCropper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: props.fileUrl,
      showCropper: props.showCropper,
      cropResult: null
    };
    this.cropImage = this.cropImage.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({ src: reader.result });
    };
    reader.readAsDataURL(files[0]);
  }

  cropImage() {
    if (typeof this.cropper.getCroppedCanvas() === "undefined") {
      return;
    }
    this.setState({
      cropResult: this.cropper.getCroppedCanvas().toDataURL()
    }, () => this.props.getCroppedImage(this.state.cropResult));
  }

  render() {
    let cropperSize = { height: 400, width: 400 };
    const {isBrand, imageCategory} = this.props;
    let aspectRatio, fullScreen;
    if (isBrand) {
      cropperSize = {};
      aspectRatio = 16 / 20;
      fullScreen = true
    } else if (imageCategory === 'mainPage') {
      aspectRatio = 24 / 18;
      fullScreen = false
    } else if (imageCategory === 'profile') {
      aspectRatio = 18 / 18;
      fullScreen = false
    } else if (imageCategory === 'logo') {
      aspectRatio = 6.2 / 5.5;
      fullScreen = false
    } else if (imageCategory === 'product') {
      aspectRatio = 2.9 / 2.4;
      fullScreen = false
    } else {
      aspectRatio = 16 / 9;
      fullScreen = false
    }
    return (
      <div>
        <Dialog
          fullScreen={fullScreen}
          fullWidth={true}
          open={this.state.showCropper}
          onClose={() => this.props.getCroppedImage(null, true)}
        >
          <MuiDialogTitle onClose={() => this.props.getCroppedImage(null, true)}>
            Crop Image
          </MuiDialogTitle>
          <DialogContent>
            <Cropper
              preview=".img-preview"
              guides={false}
              src={this.state.src}
              style={cropperSize}
              aspectRatio={aspectRatio}
              ref={cropper => {
                this.cropper = cropper;
              }}
              viewMode={1}
              dragMode="move"
              cropBoxMovable={false}
            />
            <div style={{marginTop: 10, float: 'right'}}>
            <Button
              color='primary'
              variant="contained"
              onClick={this.cropImage}>
              <ButtonContent
                text={ "Done"}
              />
            </Button>
           </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(ImageCropper);



// WEBPACK FOOTER //
// ./src/components/files/Cropper.js